import { render, staticRenderFns } from "./SupplierDiscountProducts.vue?vue&type=template&id=08db0989&"
import script from "./SupplierDiscountProducts.vue?vue&type=script&lang=js&"
export * from "./SupplierDiscountProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports